import React from "react";
import PhotoGallery from "pages/photo-gallery";
import LoginPopup from "components/login-popup";

function SharedPhotoGallery() {
  return (
    <>
      <PhotoGallery isPublic={true} />
      <LoginPopup isPublic={true} />
    </>
  );
}

export default SharedPhotoGallery;
